const loadRecaptchaScript = (siteKey) => {
  if (window.grecaptcha) return Promise.resolve()
  return new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`
    script.onload = () => window.grecaptcha.ready(resolve)
    script.onerror = () => reject(new Error('failed to load reCAPTCHA'))
    document.head.appendChild(script)
  })
}

const executeRecaptchaToken = (siteKey, action) => 
  new Promise((resolve, reject) => {
    window.grecaptcha.ready(() => {
      window.grecaptcha.execute(siteKey, { action })
        .then(resolve)
        .catch(reject)
    })
  })

const executeRecaptcha = async (siteKey, action = 'submit') => {
  if (!window.grecaptcha) await loadRecaptchaScript(siteKey)
  return executeRecaptchaToken(siteKey, action)
}

export { loadRecaptchaScript, executeRecaptcha }
